import {FIELD_TYPE} from "types/enums";

const {INPUT, SELECT, DATE, COMBO_BOX} = FIELD_TYPE;
const fields: any[] = [
  {
    type: INPUT,
    label: "Tên role",
    name: "name",
  },
  {
    type: INPUT,
    label: "Mã role SSO",
    name: "maSso",
  },
  {
    type: INPUT,
    label: "Mô tả",
    name: "description",
  },
];

const columnsBranch: any[] = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    render: (text, record, index) => index + 1,
    width: 80,
    show: true,
    align: "center",
  },
  {
    title: "Chi nhánh",
    dataIndex: "role",
    key: "role",
    type: INPUT,
    show: true,
  },
  {
    title: "",
    dataIndex: "",
    key: "action",
    align: "center",
    width: 60,
    fixed: "right" as any,
    show: true,
  },
];
const columnsKho: any[] = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    render: (text, record, index) => index + 1,
    width: 80,
    show: true,
    align: "center",
  },
  {
    title: "Kho",
    dataIndex: "role",
    key: "role",
    type: INPUT,
    show: true,
  },
  {
    title: "",
    dataIndex: "",
    key: "action",
    align: "center",
    width: 60,
    fixed: "right" as any,
    show: true,
  },
];
export {fields, columnsBranch, columnsKho};
